/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import Input, { InputProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFInputProps<
  T, Value, FormFields extends FieldValues,
> extends InputProps<T, Value>, CommonReactHookFormProps<FormFields> { }

function RHFInput<T, Value, FormFields extends FieldValues>(
  props: RHFInputProps<T, Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    iconStart,
    helperText,
    disabled,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: Value) => {
    onChange(event);
  };

  return (
    <Input
      label={label}
      iconStart={iconStart}
      value={field.value}
      helperText={helperText}
      disabled={disabled}
      onChange={handleChange}
      error={error}
      {...rest}
    />
  );
}

export default RHFInput;
